/**
 * Created by natalia.petrov on 4/4/2017.
 */
import styled from 'styled-components';
import { Button } from 'react-bootstrap';
import { getContrastWhiteBlack } from '../../../utils/helpers';

export const DefaultButton = styled(Button)`
  &.btn.btn-default {
    color: ${(props) => props.theme.buttonContent};
    background-color: ${(props) => props.theme.buttonBackground};
    border-color: ${(props) => props.theme.buttonBackgroundDarken};
  }
  &.btn.btn-default:hover {
    color: ${(props) =>
      getContrastWhiteBlack(props.theme.buttonBackgroundDarken)};
    background-color: ${(props) => props.theme.buttonBackgroundDarken};
    border-color: ${(props) => props.theme.buttonBackgroundDarken};
  }
  &.btn.btn-default[disabled]:hover {
    background-color: ${(props) => props.theme.buttonBackgroundLighten};
    color: ${(props) =>
      getContrastWhiteBlack(props.theme.buttonBackgroundLighten)};
  }
  &.btn.btn-default:target {
    background-color: ${(props) => props.theme.buttonBackgroundDarken};
    color: ${(props) => props.theme.buttonContentLighten};
  }
`;

export const PrimaryButton = styled(Button)`
  &.btn.btn-primary {
    color: ${(props) => props.theme.brandContrast};
    background-color: ${(props) => props.theme.brandColor};
    border-color: ${(props) => props.theme.brandColorDarken};
  }
  &.btn.btn-primary:hover {
    background-color: ${(props) => props.theme.brandColorDarken};
    color: ${(props) => getContrastWhiteBlack(props.theme.brandColorDarken)};
  }
`;
export const LinkButton = styled(Button)`
  &.btn.btn-link {
    color: ${(props) => props.theme.brandColor};
  }
  &.btn.btn-link:hover {
    color: ${(props) => props.theme.brandColor};
    text-decoration: none;
  }
`;

export const ChatbotButton = styled(Button)`
  &.btn.btn-primary {
    background-color: ${(props) => props.theme.chatbotBackground};
    color: ${(props) => props.theme.chatbotBorder};
    border-color: ${(props) => props.theme.chatbotBorder};
    border-width: ${'1.5px'};
  }
  &.btn.btn-primary:hover {
    background-color: ${(props) => props.theme.chatbotBorderDarken};
    color: ${(props) => getContrastWhiteBlack(props.theme.chatbotBorderDarken)};
  }
`;



// WEBPACK FOOTER //
// ./components/utils/Styled/buttons.js